
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { isPaidUser } from "../checkUser";

const useWatermark = () => {
    const [isShow, setIsShow] = useState(false);
    const { plan } = useSelector((state) => state.userDetails);
  
    useEffect(() => {
      setIsShow(!isPaidUser(plan));
    }, [plan]);
  
    return isShow;
  };

  export default useWatermark;